<template>
  <DelDialog
    width="650px"
    :dialogVisible="updateFileVisible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('projectDetailsV2.updateOriginal')}}</template>
    <!-- multiple -->
    <el-upload class="upload-demo" drag action
      :limit="1"
      :accept="acceptStr"
      :file-list="updateFile"
      :show-file-list="false"
      :on-change="uploadChange"
      :on-exceed="handleExceed"
      :before-upload="beforeUploadFile"
      :http-request="uploadSectionFile"
    >
      <div class="emptyBox" v-if="updateFile.length ? false: true">
        <div class="el-upload__text">{{$t('project.supportFormat', [$supportFileSuffixes().tip])}}<em style="display:block">{{$t('newProjectV2.singleFileSize', [20, 1])}}</em></div>
      </div>
      <div v-else class="file-upload-list">
        <el-table
          :data="updateFile"
          height="100%"
          border
          header-row-class-name="customHeader"
        >
          <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
            <template slot-scope="{ $index }">
              {{$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.name')"
            align="center"
            prop="name"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <span>{{row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.progress')"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-progress
                :stroke-width="8"
                :status="row.exception"
                :percentage="isNaN(row.percentage) ? 100 : row.percentage">
                </el-progress>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.operate')"
            align="center"
            width="100"
          >
            <template>
              <el-tooltip effect="dark" :content="$t('newProjectV2.del')" placement="top">
                <i class="el-icon-delete" @click.stop="handleDelete"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-upload>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import axios from "axios";
import { fileRepeatHandler } from '@/services/projectDetailsApi';
import { getFileLang, getUploadSign } from '@/services/newProjectApi';

export default {
  name: 'UpdateFile',
  components: {
    DelDialog
  },
  props: {
    updateFileInfo: {
      type: Object,
      require: true,
    },
    updateFileVisible: {
      type: Boolean,
      require: true,
    }
  },
  data () {
    return {
      acceptStr: this.$supportFileSuffixes().acceptStr,  // 支持文件格式
      updateFile: [],
    }
  },
  methods: {
    uploadChange (file) {
      this.updateFile.push({
        ...file,
        imgSrc: '',
        path: '',
        source: '',
        sourceLang: '',
        obp: false
      });
    },
    handleExceed () {
      this.$message.closeAll();
      this.$message.warning(this.$t('newProjectV2.maxFileNum', [1]));
    },
    beforeUploadFile (file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > 20;

      let typeFlag = this.$supportFileSuffixes(type).isSupport;

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.$supportFileSuffixes().tip]));
        // 去除最后一个文件
        this.updateFile.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.notSupportEmptyFolder'));
        return false;
      }

      if (isLt20M) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.maxUploadFileSize', [20]));
        this.updateFile.pop();
        file.obp = true;
        return false;
      }
      return true;
    },
    uploadSectionFile (param) {
      let self = this;
      // 获得上传签名
      getUploadSign().then(({ result }) => {
        self.host = result.host;
        let re = /([^\.\/\\]+)\.([a-z]+)$/i;
        let resultArr = re.exec(param.file.name);
        // 文件类型
        let type = resultArr[2].toLocaleLowerCase();

        let para = {
          ...result,
          key : `${result.keyPrefix}.${type}`,
          file: param.file,
        };
        Reflect.deleteProperty(para, 'keyPrefix');
        Reflect.deleteProperty(para, 'host');

        self.formData = new FormData();
        Object.keys(para).forEach(function (key) {
          self.formData.append(key, para[key]);
        });

        self.getFileHost(param);
      })
    },
    getFileHost (param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({percent: complete});
        }
      };

      axios.post(FileController, self.formData, config).then((resp) => {
        let { result } = resp.data;

        // self.getLong(result.fileName, param);

        self.updateFile.forEach((item, index) => {
          // 上传文件夹的param和单个上传的param不一样
          if (item.uid === param.file.uid) {
            item.path = result.fileName;
            self.$set(self.updateFile, index, item);
          }
        });
      });
    },
    // 检测语言方法
    getLong (path, param) {
      let self = this;
      getFileLang({
        path
      }).then(({ result }) => {
        // 添加源语言字段
        this.updateFile.forEach((item, index) => {
          if (item.uid === param.file.uid) {
            item.source = result.sourceLangName || "";
            item.sourceLang = result.sourceLang || '';
            self.$set(self.updateFile, index, item);
          }
        });
      });
    },
    handleDelete () {
      this.updateFile = [];
    },
    handleCancel () {
      this.updateFile = [];
      this.$emit('updateFileCancel');
    },
    async handleConfirm () {
      if (this.updateFile.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.selUploadFileTip'));
        return;
      }
      let { success } = await fileRepeatHandler({
        fileId: this.updateFileInfo.id,
        finish: this.updateFileInfo.finish,
        filePath: this.updateFile[0].path
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t('projectDetailsV2.updateSuccess'));
        this.handleCancel();
        this.$emit('updateFile');
      }
    },
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>